import Button, { ButtonProps } from "shared/Button/Button";
import React from "react";

export interface ButtonPrimaryProps extends ButtonProps {}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = "",
  ...args
}) => {
  return (
    <Button
        className={`ttnc-ButtonPrimary disabled:bg-opacity-90 bg-custom-green hover:bg-custom-green-dark text-white shadow-xl ${className}`}
      {...args}
    />
  );
};

export default ButtonPrimary;
